module.exports = __webpack_public_path__ + "static/media/bienestar2.66337cdd.jpg";